<template>
  <div>
    <div v-if="text.paragraph1">
      <Paragraph
        v-for="(item, index) in text"
        :key="index"
        v-html="item"
      ></Paragraph>
    </div>

    <div v-if="text.item1" class="line">
      <div v-for="(item, index) in text" :key="index" class="line--item">
        <div class="box-color"></div>
        <Paragraph v-html="item"></Paragraph>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Componente que apresenta textos randomicos
 * normalmente usado na sidebar
 */
import { getRandomInt } from '@/helpers/math'
import Paragraph from '@/components/_base/elements/Paragraph'

export default {
  name: 'RandomTip',
  components: {
    Paragraph
  },
  props: {
    terms: Array,
    default: () => ['Aqui vai uma dica']
  },
  computed: {
    text() {
      const pos = getRandomInt(0, this.terms.length)
      return this.terms[pos]
    }
  }
}
</script>

<style lang="scss" scoped>
.paragraph {
  line-height: 21px;
  color: $gray-darkest;

  &:first-of-type {
    margin-bottom: 16px;
  }
  &:not(:first-of-type) {
    margin-bottom: 8px;
  }
}
.line {
  &--item {
    display: flex;

    &:nth-child(3n-1) {
      .box-color {
        background-color: $cyan;
      }
    }
    &:nth-child(3n-2) {
      .box-color {
        background-color: $blue;
      }
    }
    &:nth-child(3n) {
      .box-color {
        background-color: $purple;
      }
    }

    .box-color {
      display: flex;
      height: 10px;
      margin-right: 7px;
      margin-top: 4px;
      min-width: 10px;
    }
  }
}
</style>
